import { Box, Button, Card, Modal, Typography } from "@material-ui/core";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import firebase_ from "../../../../firebase/firebase";
import { fetchUsers } from "../../utlities/FetchUsers";
import "../Task.css";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
function AddProject() {
  const [project, setProject] = useState({
    currentProject: {
      title: "",
      date: "",
      clientName: "",
    },
  });
  const db = firebase_.firestore();
  const [projectList, setProjectList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  async function fetchProjectList() {
    setProjectList([]);
    await db
      .collection("project")
      .get()
      .then((res) => {
        res.forEach((item) => {
          setProjectList((projectList) => [...projectList, item.data()]);
        });
      })
      .catch((err) => {
        console.log("Project error ", err);
      });
  }

  useEffect(() => {
    fetchProjectList();
    setUserList(fetchUsers());
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    db.collection("project")
      .add({
        title: project.currentProject.title,
        date: project.currentProject.date,
        clientName: project.currentProject.clientName,
      })
      .then((res) => {
        console.log("Added successfully", res);
        fetchProjectList();
        setProject({
          currentProject: {
            title: "",
            date: "",
            clientName: "",
          },
        });
      })
      .catch((err) => {
        console.log("Error handle", err);
      });
  };
  const handleChange = (e) => {
    setProject({
      currentProject: {
        ...project.currentProject,
        [e.target.name]: e.target.value,
      },
    });
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Text in a modal
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
          </Typography>
        </Box>
      </Modal>
      <div>
        <form onSubmit={handleSubmit}>
          <input
            className="add-question-inpt"
            onChange={handleChange}
            placeholder="Project Title"
            required
            name="title"
            type="text"
            value={project.currentProject.title}
          />
          <input
            className="add-question-inpt"
            onChange={handleChange}
            placeholder="Date"
            required
            type="date"
            name="date"
            value={project.currentProject.date}
          />
          <input
            className="add-question-inpt"
            onChange={handleChange}
            placeholder="Client Name"
            required
            name="clientName"
            value={project.currentProject.clientName}
          />
          <Button className="add-question-btn" type="submit">
            Add
          </Button>
        </form>
      </div>
      <div className="project-list">
        {projectList.map((data, index) => {
          return (
            <Card className="project-card">
              <div>
                <p>{data["title"]}</p>
                <p>{data["clientName"]}</p>
                <p>{data["date"]}</p>
              </div>
              <div className="project-button-section">
                <Button variant="contained" color="secondary">
                  View Details
                </Button>
                <Button onClick={handleOpen} variant="outlined" color="primary">
                  Team
                </Button>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

export default AddProject;
